import React from 'react';
import _ from 'lodash';
import PIVIcon from 'go/images/PIV_Icon.jpg';
import {Button, Grid, Header, Image, Segment} from 'semantic-ui-react';
import {ENDPOINT_SAML} from 'app-ui-componentlibrary/dist/common/endpoints';

export default class PIVLogin extends React.Component {
  handleClick = () => {
    window.location.href = `${ENDPOINT_SAML}saml/authenticate`; // do not ever change this endpoint from auth/api/v1/ or this will break
  };
  render() {
    let headerText = 'FEMA employees';
    let buttonText = 'Log in with your PIV card';
    if (_.get(this.props, 'loginGovIntegration', false)) {
      headerText += ' and partners';
      buttonText = 'Sign in with your PIV card';
    }
    return (
      <Segment>
        <Header as="h3" dividing color="blue">
          {headerText}
        </Header>
        <Grid>
          <Grid.Column width="6">
            <Image alt="PIV card" src={PIVIcon} />
          </Grid.Column>
          <Grid.Column width="10">
            <p>Insert your PIV card into your smart card reader</p>
            <Button primary compact onClick={this.handleClick}>
              {buttonText}
            </Button>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}
